import React from 'react';
import { Building2 } from 'lucide-react';

/**
 * Small badge shown next to a member's name in Klubb-logg admin view
 * when the member is also active in other clubs.
 *
 * Props:
 *   otherClubs: [{id, name}, ...] - list of OTHER clubs (not current)
 */
const MultiClubBadge = ({ otherClubs }) => {
  if (!otherClubs || !Array.isArray(otherClubs) || otherClubs.length === 0) {
    return null;
  }

  const clubNames = otherClubs
    .map((c) => (typeof c === 'string' ? c : c?.name))
    .filter(Boolean);

  if (clubNames.length === 0) return null;

  return (
    <span
      className="relative inline-flex group cursor-help align-middle"
      data-testid="multi-club-badge-wrapper"
    >
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 bg-purple-500/20 text-purple-300 text-[10px] rounded-full font-medium border border-purple-500/40"
        data-testid="multi-club-badge"
      >
        <Building2 className="h-2.5 w-2.5" />
        <span>+{clubNames.length}</span>
      </span>

      {/* Custom tooltip - visible on hover */}
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50 hidden group-hover:block whitespace-nowrap rounded-md bg-gray-900 border border-purple-500/40 px-3 py-2 text-xs text-white shadow-xl"
        data-testid="multi-club-badge-tooltip"
      >
        <span className="block text-[10px] font-semibold text-purple-300 uppercase tracking-wide mb-1">
          Også medlem i
        </span>
        {clubNames.map((name, i) => (
          <span key={i} className="block text-white">
            • {name}
          </span>
        ))}
        {/* Little arrow */}
        <span className="absolute left-1/2 -translate-x-1/2 top-full h-2 w-2 -mt-1 rotate-45 bg-gray-900 border-r border-b border-purple-500/40"></span>
      </span>
    </span>
  );
};

export default MultiClubBadge;
